export enum ActionTypes {
    SET_DIRTY_STATE = 'SET_DIRTY_STATE'
}
